import {styled} from '@mui/material';
import Image from '@jobseeker/lotus/components/Image';

const Logo = styled(Image)<any>(props => ({
  width: '15rem',
  padding: props.theme.spacing(3),
}));

const Link = styled('a')<any>(props => ({
  color: props.isButton
    ? props.theme.palette.secondary.main
    : props.theme.palette.primary.contrastText,
  opacity: 0.7,
  fontSize: props.theme.typography.pxToRem(24),
  margin: props.isButton
    ? 'unset'
    : props.elIndex
    ? props.theme.spacing(0, 1)
    : props.theme.spacing(0, 1, 0, 0),
  padding: props.isButton ? props.theme.spacing(1) : 'unset',
  lineHeight: 0,
  borderRadius: '10px',
  display: 'inline-block',
  transition: 'all 0.3s',
  cursor: 'pointer',
  backgroundColor: props.isButton
    ? props.theme.palette.secondary.contrastText
    : 'transparent',
  ':hover': {
    opacity: 1,
  },
  p: {
    display: 'inline-block',
    margin: 0,
    fontSize: props.theme.typography.pxToRem(18),
    lineHeight: props.theme.typography.pxToRem(24),
  },
}));

export {Logo, Link};
